import $ from "jquery";
/* eslint-disable */
export default function book() {
  $(".booking-form input[type=radio][name=season]").change(function () {
    $(".js-choose-course-validation").removeClass("is-inactive");
    seasonCookie(this.value);
    seasonIdCookie($(".booking-form input[name=season]:checked").attr('data-season_id'));
    if ($(this).hasClass("active")) {
    } else {
      if ($(".booking-form .season").hasClass("active") && $(".booking-form .sport").hasClass("active") && $(".booking-form .country").hasClass("active") && $(".booking-form .resort").hasClass("active")) {
        var $season = $(".booking-form input[name=season]:checked").val();
        var $value = $(".booking-form input[name=resort]:checked").val();
        var $sport = $(".booking-form input[name=sport]:checked").val();
        $(".booking-form .courses .content").slideUp();
        $(".booking-form .dates .content").slideUp();
        $(".booking-form .courses .loading").fadeIn();
        $(".booking-form .dates .loading").fadeIn();
        if ($(".booking-form .accommodation").hasClass("active")) {
          $(".booking-form .accommodation .content").slideUp();
          $(".booking-form .optional-extras .content").slideUp();
          $(".booking-form .accommodation .loading").fadeIn();
          $(".booking-form .optional-extras .loading").fadeIn();
        }
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_courses",
            value: $value,
            sport: $sport,
            season: $season,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .courses .content").html(response);
            $(".booking-form .dates .content").html(
              '<p class="text-lightgrey">Please select a course</p>'
            );
            $(".booking-form .courses .loading").fadeOut();
            $(".booking-form .dates .loading").fadeOut();
            $(".booking-form .courses .content").slideDown();
            $(".booking-form .dates .content").slideDown();
            if ($(".booking-form .accommodation").hasClass("active")) {
              $(".booking-form .accommodation .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .optional-extras .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .accommodation .content").slideDown();
              $(".booking-form .optional-extras .content").slideDown();
              $(".booking-form .accommodation .loading").fadeOut();
              $(".booking-form .optional-extras .loading").fadeOut();
              $(".booking-form .accommodation").removeClass("active");
            }
            book();
          },
        });
      }
      $(".booking-form input[type=radio][name=season]").removeClass("active");
      $(this).addClass("active");
      if ($(".booking-form .sport").hasClass("active")) {
      } else {
        $(".booking-form .sport").addClass("active");
        $(".booking-form .sport .loading").fadeIn();
        $(".booking-form .sport .content").slideUp();
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_sports",
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .sport .content").html(response);
            $(".booking-form .sport .loading").fadeOut();
            $(".booking-form .sport .content").slideDown();
            book();
          },
        });
        $(".booking-form .sport").slideDown();
      }
    }
    $(".booking-form .season").addClass("active");
    if ($(".booking-form .dates").hasClass("active")) {
      $(".booking-form .dates").removeClass("active");
      resetSummary();
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
    if ($("#package-total").hasClass("active")) {
      var current = $("#package-total span").text();
      $("#package-total span")
        .prop("Counter", current)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#package-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package").val(Number(newtotal));
      var deposit = $("#deposit-total span").text();
      $("#deposit-total span")
        .prop("Counter", deposit)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#deposit-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package-total").removeClass("active");
    }
  });

  $(".booking-form input[type=radio][name=sport]").change(function () {
    $(".js-choose-course-validation").removeClass("is-inactive");
    sportCookie(this.value);
    if ($(this).hasClass("active")) {
    } else {
      $(".booking-form input[type=radio][name=sport]").removeClass("active");
      $(this).addClass("active");
      if ($(".booking-form .season").hasClass("active") && $(".booking-form .sport").hasClass("active") && $(".booking-form .country").hasClass("active") && $(".booking-form .resort").hasClass("active")) {
        var $value = $(".booking-form input[name=resort]:checked").val();
        var $sport = $(".booking-form input[name=sport]:checked").val();
        var $season = $(".booking-form input[name=season]:checked").val();
        $(".booking-form .courses .content").slideUp();
        $(".booking-form .dates .content").slideUp();
        $(".booking-form .courses .loading").fadeIn();
        $(".booking-form .dates .loading").fadeIn();
        if ($(".booking-form .accommodation").hasClass("active")) {
          $(".booking-form .accommodation .content").html(
            '<p class="text-lightgrey">Please fill out all previous fields</p>'
          );
          $(".booking-form .optional-extras .content").html(
            '<p class="text-lightgrey">Please fill out all previous fields</p>'
          );
          $(".booking-form .accommodation .content").slideUp();
          $(".booking-form .optional-extras .content").slideUp();
          $(".booking-form .accommodation .loading").fadeIn();
          $(".booking-form .optional-extras .loading").fadeIn();
        }
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_courses",
            value: $value,
            sport: $sport,
            season: $season,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .courses .content").html(response);
            $(".booking-form .dates .content").html(
              '<p class="text-lightgrey">Please select a course</p>'
            );
            $(".booking-form .courses .loading").fadeOut();
            $(".booking-form .dates .loading").fadeOut();
            $(".booking-form .courses .content").slideDown();
            $(".booking-form .dates .content").slideDown();
            book();
          },
        });
      } else {
        if ($(".booking-form .country").hasClass("active")) {
          $(".booking-form .country .loading").fadeIn();
          $(".booking-form .country .content").slideUp();
          $.ajax({
            url: ajax_object.ajax_url,
            data: {
              action: "book_countries",
            },
            type: "POST",
            success: function (response) {
              $(".booking-form .country .content").html(response);
              $(".booking-form .country .loading").fadeOut();
              $(".booking-form .country .content").slideDown();
              if ($(".booking-form .accommodation").hasClass("active")) {
                $(".booking-form .accommodation .content").html(
                  '<p class="text-lightgrey">Please fill out all previous fields</p>'
                );
                $(".booking-form .optional-extras .content").html(
                  '<p class="text-lightgrey">Please fill out all previous fields</p>'
                );
                $(".booking-form .accommodation .content").slideDown();
                $(".booking-form .optional-extras .content").slideDown();
                $(".booking-form .accommodation .loading").fadeOut();
                $(".booking-form .optional-extras .loading").fadeOut();
                $(".booking-form .accommodation").removeClass("active");
              }
              book();
            },
          });
        } else {
          $(".booking-form .country").addClass("active");
          $(".booking-form .country .loading").fadeIn();
          $(".booking-form .country .content").slideUp();
          $.ajax({
            url: ajax_object.ajax_url,
            data: {
              action: "book_countries",
            },
            type: "POST",
            success: function (response) {
              $(".booking-form .country .content").html(response);
              $(".booking-form .country .loading").fadeOut();
              $(".booking-form .country .content").slideDown();
              book();
            },
          });
        }
      }
    }
    $(".booking-form .sport").addClass("active");
    if ($(".booking-form .dates").hasClass("active")) {
      $(".booking-form .dates").removeClass("active");
      resetSummary();
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
    if ($("#package-total").hasClass("active")) {
      var current = $("#package-total span").text();
      $("#package-total span")
        .prop("Counter", current)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#package-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package").val(Number(newtotal));
      var deposit = $("#deposit-total span").text();
      $("#deposit-total span")
        .prop("Counter", deposit)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#deposit-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package-total").removeClass("active");
    }
  });

  $(".booking-form input[type=radio][name=country]").change(function () {
    var $value = this.value;
    countryCookie(this.value);
    $(".js-choose-course-validation").removeClass("is-inactive");
    if ($(this).hasClass("active")) {
    } else {
      if (
        $(".booking-form .season").hasClass("active") &&
        $(".booking-form .sport").hasClass("active") &&
        $(".booking-form .country").hasClass("active") &&
        $(".booking-form .resort").hasClass("active")
      ) {
        $(".booking-form input[type=radio][name=country]").removeClass(
          "active"
        );
        $(this).addClass("active");
        $(".booking-form .resort .loading").fadeIn();
        $(".booking-form .courses .loading").fadeIn();
        $(".booking-form .dates .loading").fadeIn();
        $(".booking-form .resort .content").slideUp();
        $(".booking-form .courses .content").slideUp();
        $(".booking-form .dates .content").slideUp();
        if ($(".booking-form .accommodation").hasClass("active")) {
          $(".booking-form .accommodation .content").slideUp();
          $(".booking-form .optional-extras .content").slideUp();
          $(".booking-form .accommodation .loading").fadeIn();
          $(".booking-form .optional-extras .loading").fadeIn();
        }
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_resorts",
            value: $value,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .resort .content").html(response);
            $(".booking-form .resort .loading").fadeOut();
            $(".booking-form .resort .content").slideDown();
            $(".booking-form .courses .content").html(
              '<p class="text-lightgrey">Please fill out all previous fields</p>'
            );
            $(".booking-form .courses .loading").fadeOut();
            $(".booking-form .courses .content").slideDown();
            $(".booking-form .dates .content").html(
              '<p class="text-lightgrey">Please select a course</p>'
            );
            $(".booking-form .dates .loading").fadeOut();
            $(".booking-form .dates .content").slideDown();
            if ($(".booking-form .accommodation").hasClass("active")) {
              $(".booking-form .accommodation .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .optional-extras .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .accommodation .content").slideDown();
              $(".booking-form .optional-extras .content").slideDown();
              $(".booking-form .accommodation .loading").fadeOut();
              $(".booking-form .optional-extras .loading").fadeOut();
              $(".booking-form .accommodation").removeClass("active");
            }
            book();
          },
        });
      } else {
        $(".booking-form input[type=radio][name=country]").removeClass(
          "active"
        );
        $(this).addClass("active");
        $(".booking-form .resort .loading").fadeIn();
        $(".booking-form .resort .content").slideUp();
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_resorts",
            value: $value,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .resort .content").html(response);
            $(".booking-form .resort .loading").fadeOut();
            $(".booking-form .resort .content").slideDown();
            book();
          },
        });
      }
    }
    $(".booking-form .country").addClass("active");
    if ($(".booking-form .dates").hasClass("active")) {
      $(".booking-form .dates").removeClass("active");
      resetSummary();
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
    if ($("#package-total").hasClass("active")) {
      var current = $("#package-total span").text();
      $("#package-total span")
        .prop("Counter", current)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#package-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package").val(Number(newtotal));
      var deposit = $("#deposit-total span").text();
      $("#deposit-total span")
        .prop("Counter", deposit)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#deposit-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package-total").removeClass("active");
    }
  });

  $(".booking-form input[type=radio][name=resort]").change(function () {
    var $value = this.value;
    var $sport = $(".booking-form input[name=sport]:checked").val();
    var $season = $(".booking-form input[name=season]:checked").val();
    resortCookie(this.value);
    $(".js-choose-course-validation").removeClass("is-inactive");
    if ($(this).hasClass("active")) {
    } else {
      $(".booking-form input[type=radio][name=resort]").removeClass("active");
      $(this).addClass("active");
      if (
        $(".booking-form .season").hasClass("active") &&
        $(".booking-form .sport").hasClass("active") &&
        $(".booking-form .country").hasClass("active") &&
        $(".booking-form .resort").hasClass("active")
      ) {
        $(".booking-form .courses .content").slideUp();
        $(".booking-form .dates .content").slideUp();
        $(".booking-form .courses .loading").fadeIn();
        $(".booking-form .dates .loading").fadeIn();

        if ($(".booking-form .accommodation").hasClass("active")) {
          $(".booking-form .accommodation .content").slideUp();
          $(".booking-form .optional-extras .content").slideUp();
          $(".booking-form .accommodation .loading").fadeIn();
          $(".booking-form .optional-extras .loading").fadeIn();
        }

        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_courses",
            value: $value,
            sport: $sport,
            season: $season,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .courses .content").html(response);
            $(".booking-form .dates .content").html(
              '<p class="text-lightgrey">Please select a course</p>'
            );
            $(".booking-form .courses .loading").fadeOut();
            $(".booking-form .dates .loading").fadeOut();
            $(".booking-form .courses .content").slideDown();
            $(".booking-form .dates .content").slideDown();

            if ($(".booking-form .accommodation").hasClass("active")) {
              $(".booking-form .accommodation .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .optional-extras .content").html(
                '<p class="text-lightgrey">Please fill out all previous fields</p>'
              );
              $(".booking-form .accommodation .content").slideDown();
              $(".booking-form .optional-extras .content").slideDown();
              $(".booking-form .accommodation .loading").fadeOut();
              $(".booking-form .optional-extras .loading").fadeOut();
              $(".booking-form .accommodation").removeClass("active");
            }
            book();
          },
        });
      } else {
        $(".booking-form .courses .content").slideUp();
        $(".booking-form .courses .loading").fadeIn();
        $.ajax({
          url: ajax_object.ajax_url,
          data: {
            action: "book_courses",
            value: $value,
            sport: $sport,
            season: $season,
          },
          type: "POST",
          success: function (response) {
            $(".booking-form .courses .content").html(response);
            $(".booking-form .courses .loading").fadeOut();
            $(".booking-form .courses .content").slideDown();
            book();
          },
        });
      }
    }
    $(".booking-form .resort").addClass("active");
    if ($(".booking-form .dates").hasClass("active")) {
      $(".booking-form .dates").removeClass("active");
      resetSummary();
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
    if ($("#package-total").hasClass("active")) {
      var current = $("#package-total span").text();
      $("#package-total span")
        .prop("Counter", current)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#package-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package").val(Number(newtotal));
      var deposit = $("#deposit-total span").text();
      $("#deposit-total span")
        .prop("Counter", deposit)
        .animate(
          {
            Counter: 0,
          },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#deposit-total span").text(Math.ceil(now));
            },
          }
        );
      $("#package-total").removeClass("active");
    }
  });

  $(".booking-form input[type=radio][name=type_course]").change(function () {
    $(".booking-form .course").addClass("active");
    $(".js-choose-course-validation").removeClass("is-inactive");
    var $value = this.value;
    var $course_id = $(this).attr("data-id");
    courseCookie($course_id);
    if ($(this).hasClass("active")) {
    } else {
      $(".booking-form input[type=radio][name=type_course]").removeClass(
        "active"
      );
      var $season = $(".booking-form input[name=season]:checked").val();
      $(this).addClass("active");

      $(".booking-form .dates .content").slideUp();
      $(".booking-form .dates .loading").fadeIn();
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "book_dates",
          value: $value,
          season: $season,
        },
        type: "POST",
        success: function (response) {
          $(".booking-form .dates .content").html(response);
          $(".booking-form .dates .loading").fadeOut();
          $(".booking-form .dates .content").slideDown();
          var current = $("#package-total span").text();
          var total = $(".booking-form input[type=radio][name=type_course]:checked")
            .siblings("label")
            .find(".total")
            .text();
          var base_deposit = $(".booking-form input[type=radio][name=type_course]:checked")
            .siblings("label")
            .find(".deposit")
            .text();
          $("#package-total span")
            .prop("Counter", current)
            .animate(
              {
                Counter: total,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#package-total span").text(Math.ceil(now));
                },
              }
            );
          $("#package").val(Number(total));
          var deposit = $("#deposit-total span").text();
          if (!base_deposit) {
            // base_deposit = total / 10;
            base_deposit = total;
          }

          $("#deposit-total").attr("data-base-deposit", base_deposit);
          $("#deposit-total").attr("data-date-deposit", "0");

          var initial_deposit = parseInt(
            $("#deposit-total").attr("data-base-deposit")
          );
          var room_deposit = parseInt(
            $("#deposit-total").attr("data-room-deposit")
          );
          var extras_deposit = parseInt(
            $("#deposit-total").attr("data-extras-deposit")
          );

          var current_deposit = room_deposit + initial_deposit + extras_deposit;
          current_deposit = parseInt(current_deposit);
          var deposit = $("#deposit-total span").text();

          $("#deposit-total span")
            .prop("Counter", deposit)
            .animate(
              {
                Counter: current_deposit,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#deposit-total span").text(Math.ceil(now));
                },
              }
            );
          $("#package-total").addClass("active");
          book();
        },
      });
    }
    if ($(".booking-form .dates").hasClass("active")) {
      $(".booking-form .dates").removeClass("active");
      resetSummary();
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
  });

  $(".booking-form input[type=radio][name=date]").change(function () {
    $(".booking-form .dates").addClass("active");
    var $value = $(".booking-form input[name=type_course]:checked").val();
    var $sport = $(".booking-form input[name=sport]:checked").val();
    var $destination = $(".booking-form input[name=country]:checked").val();
    var $resort = $(".booking-form input[name=resort]:checked").val();
    var $season = $(".booking-form input[name=season]:checked").val();
    var $dates = $(".booking-form input[name=date]:checked").val();
    var $price = $(".booking-form input[name=date]:checked").attr("data-price");
    if ($(this).hasClass("active")) {
    } else {
      $(".booking-form input[type=radio][name=date]").removeClass("active");
      $(this).addClass("active");

      $(".booking-form .accommodation .content").slideUp();
      $(".booking-form .accommodation .loading").fadeIn();
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "book_rooms",
          value: $value,
          price: $price,
          dates: $dates,
        },
        type: "POST",
        success: function (response) {
          $(".booking-form .accommodation .content").html(response);
          $(".booking-form .accommodation .loading").fadeOut();
          $(".booking-form .accommodation .content").slideDown();
          book();
        },
      }),
        $(".booking-form .optional-extras .content").slideUp();
      $(".booking-form .optional-extras .loading").fadeIn();
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "book_extras",
          value: $value,
          dates: $dates,
        },
        type: "POST",
        success: function (response) {
          $(".booking-form .optional-extras .content").html(response);
          $(".booking-form .optional-extras .loading").fadeOut();
          $(".booking-form .optional-extras .content").slideDown();
          book();
        },
      }),
        $(".course-content").slideUp();

      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "book_summary",
          course: $value,
          sport: $sport,
          destination: $destination,
          resort: $resort,
          season: $season,
          dates: $dates,
        },
        type: "POST",
        success: function (response) {
          $(".js-choose-course-validation").addClass("is-inactive");
          $(".course-content").html(response);
          $(".course-content").slideDown();
          var current = $("#package-total span").text();
          var total = $(
            ".booking-form input[type=radio][name=date]:checked"
          ).data("price");
          var date_deposit = $(
            ".booking-form input[type=radio][name=date]:checked"
          ).data("deposit-amount");
          $("#package-total span")
            .prop("Counter", current)
            .animate(
              {
                Counter: total,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#package-total span").text(Math.ceil(now));
                },
              }
            );
          $("#package").val(Number(total));
          var deposit = $("#deposit-total span").text();
          $("#deposit-total").attr("data-date-deposit", date_deposit);

          var initial_deposit = parseInt(
            $("#deposit-total").attr("data-base-deposit")
          );
          var date_deposit = parseInt(
            $("#deposit-total").attr("data-date-deposit")
          );
          var room_deposit = parseInt(
            $("#deposit-total").attr("data-room-deposit")
          );
          var extras_deposit = parseInt(
            $("#deposit-total").attr("data-extras-deposit")
          );

          if (date_deposit) {
            initial_deposit = date_deposit;
          }
          var current_deposit = room_deposit + initial_deposit + extras_deposit;
          current_deposit = parseInt(current_deposit);
          var deposit = $("#deposit-total span").text();

          $("#deposit-total span")
            .prop("Counter", deposit)
            .animate(
              {
                Counter: current_deposit,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#deposit-total span").text(Math.ceil(now));
                },
              }
            );
          $("#package-total").addClass("active");
          book();
        },
      });
    }
    if ($(".booking-form .accommodation").hasClass("active")) {
      $(".booking-form .accommodation").removeClass("active");
      resetAccommodation();
    }
    if ($(".booking-form .optional-extras").hasClass("active")) {
      $(".booking-form .optional-extras").removeClass("active");
      resetExtras();
    }
  });

  $(".booking-form input[type=radio][name=room]").change(function () {
    var $room = $(this).val();
    var $id = $(this).attr("data-id");
    var $course = $(".booking-form input[name=type_course]:checked").attr(
      "data-id"
    );
    var $roomprice = $(".booking-form input[name=room]:checked").attr(
      "data-price"
    );
    var $roomtitle = $(".booking-form input[name=room]:checked").attr(
      "data-roomtitle"
    );
    var $price = $(".booking-form input[name=date]:checked").attr("data-price");
    $(".booking-form .accommodation").addClass("active");
    if ($(this).hasClass("active")) {
    } else {
      $(".booking-form input[type=radio][name=room]").removeClass("active");
      $(this).addClass("active");
      $(".accommodation-content").slideUp();
      $.ajax({
        url: ajax_object.ajax_url,
        data: {
          action: "book_accommodation",
          room: $room,
          id: $id,
          price: $price,
          course: $course,
          roomprice: $roomprice,
          roomtitle: $roomtitle,
        },
        type: "POST",
        success: function (response) {
          $(".accommodation-content").html(response);
          $(".accommodation-content").slideDown();

          var currenttotal = parseInt($(".accomm-wrap input.active").data("price"), 10) + parseInt($price, 10);
          var room_deposit = $(".accomm-wrap input.active").data(
            "room-deposit"
          );
          var starttotal = parseInt($("#package-total span").text(), 10);

          if (!room_deposit) {
            // room_deposit = $roomprice / 10;
            room_deposit = $roomprice;
          }
          // $("#deposit-total").attr("data-room-deposit", room_deposit);

          $("#package-total span")
            .prop("Counter", starttotal)
            .animate(
              {
                Counter: currenttotal,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#package-total span").text(Math.ceil(now));
                },
              }
            );
          $("#package").val(Number(currenttotal));
          var initial_deposit = parseInt(
            $("#deposit-total").attr("data-base-deposit")
          );
          var date_deposit = parseInt(
            $("#deposit-total").attr("data-date-deposit")
          );
          var room_deposit = parseInt(
            $("#deposit-total").attr("data-room-deposit")
          );
          var extras_deposit = parseInt(
            $("#deposit-total").attr("data-extras-deposit")
          );

          if (date_deposit) {
            initial_deposit = date_deposit;
          }

          var current_deposit = room_deposit + initial_deposit + extras_deposit;
          current_deposit = parseInt(current_deposit);
          var deposit = $("#deposit-total span").text();

          $("#deposit-total span")
            .prop("Counter", deposit)
            .animate(
              {
                Counter: current_deposit,
              },
              {
                duration: 1000,
                easing: "swing",
                step: function (now) {
                  $("#deposit-total span").text(Math.ceil(now));
                },
              }
            );
          book();
        },
      });
    }
  });

  $(".booking-form input.extra[type=checkbox]").change(function () {
    $(".booking-form .optional-extras").addClass("active");
    var extras = [];
    var id = $(".booking-form input[name=type_course]:checked").attr("data-id");
    var dates = $(this).attr("data-dateid");
    $(".booking-form input.extra[type=checkbox]:checked").each(function (
      index
    ) {
      extras.push($(this).attr("value"));
    });
    $(".extras-content").slideUp();
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: "book_extras_summary",
        extras: extras,
        id: id,
        dates: dates,
      },
      type: "POST",
      success: function (response) {
        $(".extras-content").html(response);
        $(".extras-content").slideDown();
        var current = $("#extras-total span").text();
        var total = 0;
        var extrasDeposit = 0;
        $("#extras-price span").each(function (index) {
          var price = parseInt($(this).text(), 10);
          var deposit = parseInt($(this).parent().attr("data-extra-deposit"));
          if (!deposit) {
            // parseInt((deposit = price / 10), 10);
            parseInt((deposit = price), 10);
          }
          total = total + price;
          extrasDeposit = extrasDeposit + deposit;
          // $("#deposit-total").attr("data-extras-deposit", extrasDeposit);
        });
        $("#extras-total span")
          .prop("Counter", current)
          .animate(
            {
              Counter: total,
            },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $("#extras-total span").text(Math.ceil(now));
              },
            }
          );

        var currenttotal = parseInt($("#course-total span").text(), 10);
        var starttotal = parseInt($("#package-total span").text(), 10);
        console.log("currenttotal  => ", currenttotal);
        if (Number.isNaN(currenttotal)) {
          currenttotal = 0;
          console.log("currenttotal  2 => ", currenttotal);
        }
        var newtotal = currenttotal + total;
        $("#package-total span")
          .prop("Counter", starttotal)
          .animate(
            {
              Counter: newtotal,
            },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $("#package-total span").text(Math.ceil(now));
              },
            }
          );
        $("#package").val(Number(newtotal));

        var initial_deposit = parseInt(
          $("#deposit-total").attr("data-base-deposit")
        );
        var date_deposit = parseInt(
          $("#deposit-total").attr("data-date-deposit")
        );
        var room_deposit = parseInt(
          $("#deposit-total").attr("data-room-deposit")
        );
        var extras_deposit = parseInt(
          $("#deposit-total").attr("data-extras-deposit")
        );

        if (date_deposit) {
          initial_deposit = date_deposit;
        }

        var current_deposit = room_deposit + initial_deposit + extras_deposit;
        current_deposit = parseInt(current_deposit);
        var deposit = $("#deposit-total span").text();
        $("#deposit-total span")
          .prop("Counter", deposit)
          .animate(
            {
              Counter: current_deposit,
            },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $("#deposit-total span").text(Math.ceil(now));
              },
            }
          );
        // book();
      },
    });
  });
}

jQuery(document).ready(function ($) {

  $('#bookingSummary').on('submit', function (e) {
    e.preventDefault(); // Prevent default submission


    console.log('Form :', $('#bookingSummary'));

    var formData = {};
    var $season = {};
    var $sport = {};
    var $country = {};
    var $resort = {};
    var $type_course = {};
    var $date = {};
    formData["course"] = {};


    var $property = {};
    var $room_type = {};
    formData["accommodation"] = {};
    formData["optional_extras"] = {};
    formData["personal_details"] = {};
    formData["additional_information"] = {};
    formData["terms_and_conditions"] = {};




    formData["action"] = "book";
    formData["package_total"] = $("#package-total span").text();
    formData["deposit_total"] = $("#deposit-total span").text();

    $season["season_id"] = $(".booking-form input[name=season]:checked").attr("data-season_id");
    $season["season_value"] = $(".booking-form input[name=season]:checked").val();
    formData["course"]["season"] = $season;

    $sport["sport_id"] = $(".booking-form input[name=sport]:checked").attr("data-sport_id");
    $sport["sport_value"] = $(".booking-form input[name=sport]:checked").val();
    formData["course"]["sport"] = $sport;

    $country["country_id"] = $(".booking-form input[name=country]:checked").attr("data-country_id");
    $country["country_value"] = $(".booking-form input[name=country]:checked").val();
    formData["course"]["country"] = $country;

    $resort["resort_id"] = $(".booking-form input[name=resort]:checked").attr("data-resort_id");
    $resort["resort_value"] = $(".booking-form input[name=resort]:checked").val();
    formData["course"]["resort"] = $resort;

    $type_course["type_course_id"] = $(".booking-form input[name=type_course]:checked").attr("data-id");
    $type_course["type_course_value"] = $(".booking-form input[name=type_course]:checked").val();
    formData["course"]["type_course"] = $type_course;

    $date["date_id"] = $(".booking-form input[name=date]:checked").val();
    $date["date_value"] = $(".booking-form input[name=date]:checked").attr("data-label");
    formData["course"]["date"] = $date;

    $property["property_id"] = $(".booking-form input[name=room]:checked").attr("data-id");
    $property["property_value"] = $(".booking-form input[name=room]:checked").attr("data-roomtitle");
    formData["accommodation"]["property"] = $property;


    var package_total = parseInt($("#package-total span").text(), 10);
    var deposit_total = $("#deposit-total span").text();
    var price = $(".booking-form input[name=date]:checked").attr("data-price");
    
    $room_type["package_total"] = package_total;
    $room_type["deposit_total"] = deposit_total;
    $room_type["price_amount"] = price;

    $room_type["room_type_id"] = $(".booking-form input[name=room]:checked").attr("data-room_type_id");
    $room_type["room_type_value"] = $(".booking-form input[name=room]:checked").attr("data-room_type_name");
    $room_type["room_type_price"] = $(".booking-form input[name=room]:checked").attr("data-price");

    formData["accommodation"]["room_type"] = $room_type;

    var $extras = [];
    $(".booking-form input.extra[type=checkbox]:checked").each(function (index) {
      $extras.push({
        "extra_id": $(this).attr("data-id"),
        "extra_value": $(this).attr("value"),
        "extra_price": $(this).attr("data-extra_price"),
      });
    });
    formData["optional_extras"] = $extras;


    formData["personal_details"]['title'] = $(".booking-form select[name=title]").val();
    formData["personal_details"]['gender'] = $(".booking-form select[name=gender]").val();
    formData["personal_details"]['firstname'] = $(".booking-form input[name=firstname]").val();
    formData["personal_details"]['surname'] = $(".booking-form input[name=surname]").val();
    formData["personal_details"]['dob'] = $(".booking-form input[name=dob]").val();
    formData["personal_details"]['email'] = $(".booking-form input[name=email]").val();
    formData["personal_details"]['addressline1'] = $(".booking-form input[name=addressline1]").val();
    formData["personal_details"]['addressline2'] = $(".booking-form input[name=addressline2]").val();
    formData["personal_details"]['city'] = $(".booking-form input[name=city]").val();
    formData["personal_details"]['county'] = $(".booking-form input[name=county]").val();
    formData["personal_details"]['address-country'] = $(".booking-form input[name=address-country]").val();
    formData["personal_details"]['postcode'] = $(".booking-form input[name=postcode]").val();
    formData["personal_details"]['experience'] = $(".booking-form input[name=experience]").val();
    formData["personal_details"]['ability'] = $(".booking-form select[name=ability]").val();

    formData["additional_information"]['joining'] = $(".booking-form input[name=joining]").val();
    formData["additional_information"]['reason'] = $(".booking-form select[name=reason]").val();
    formData["additional_information"]['recall'] = $(".booking-form input[name=recall]").val();
    formData["additional_information"]['hear'] = $(".booking-form textarea[name=hear]").val();
    formData["additional_information"]['medical'] = $(".booking-form textarea[name=medical]").val();
    formData["additional_information"]['anything_else'] = $(".booking-form textarea[name=anything_else]").val();

    formData["terms_and_conditions"]['terms-conditions'] = $(".booking-form input[name=terms-conditions]:checked").val();
    formData["terms_and_conditions"]['connected'] = $(".booking-form input[name=connected]:checked").val();

    let jsonData = JSON.stringify(formData);

    // Store the JSON string in a cookie
    document.cookie = "booking_summary_data=" + encodeURIComponent(jsonData) + "; path=/; max-age=" + (30 * 24 * 60 * 60);


    window.location.href = $('#bookingSummary').attr("data-action");
  });
  loadFirst();
});

$(".booking-form .anchor").click(function () {
  var id = $(this).attr("id");
  var lastChar = id.substr(id.length - 1);
  if ($(".booking-form #step-" + lastChar + "-content").hasClass("active")) {
  } else {
    $(".booking-form #step-" + lastChar + " .icon").toggleText("+", "-");
    $(".booking-form #step-" + lastChar + "-content").slideDown();
    $(".booking-form #step-" + lastChar + "-content").addClass("active");
  }
});

$(".booking-form .trigger").click(function () {
  var id = $(this).attr("id");
  var lastChar = id.substr(id.length - 1);
  if ($(".booking-form #step-" + lastChar + "-content").hasClass("active")) {
    $(".booking-form #step-" + lastChar + " .icon").toggleText("+", "-");
    $(".booking-form #step-" + lastChar + "-content").slideUp();
    $(".booking-form #step-" + lastChar + "-content").removeClass("active");
  } else {
    $(".booking-form #step-" + lastChar + " .icon").toggleText("+", "-");
    $(".booking-form #step-" + lastChar + "-content").slideDown();
    $(".booking-form #step-" + lastChar + "-content").addClass("active");
  }
});

function resetSummary() {
  $(".course-content").slideUp("", function () {
    $(".course-content")
      .delay(1000)
      .html('<p class="text-lightgrey">Please select some options</p>')
      .slideDown();
  });
}

function resetAccommodation() {
  $(".accommodation-content").slideUp("", function () {
    $(".accommodation-content")
      .delay(1000)
      .html('<p class="text-lightgrey">Please select your accommodation</p>')
      .slideDown();
  });
}

function resetExtras() {
  $(".extras-content").slideUp("", function () {
    $(".extras-content")
      .delay(1000)
      .html('<p class="text-lightgrey">No optional extras selected</p>')
      .slideDown();
  });
  var current = $("#extras-total span").text();
  var total = 0;
  $("#extras-total span")
    .prop("Counter", current)
    .animate(
      {
        Counter: total,
      },
      {
        duration: 1000,
        easing: "swing",
        step: function (now) {
          $("#extras-total span").text(Math.ceil(now));
        },
      }
    );
}

function seasonCookie($season) {
  document.cookie =
    "selected_season=" + $season + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}

function sportCookie($sport) {
  document.cookie =
    "selected_sport=" + $sport + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}

function countryCookie($country) {
  document.cookie =
    "selected_country=" + $country + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}

function courseCookie($course_id) {
  document.cookie =
    "selected_course=" + $course_id + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}

function resortCookie($resort) {
  document.cookie =
    "selected_resort=" + $resort + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}
function slotCookie($resort) {
  document.cookie =
    "selected_slot=" + $resort + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}

$(".js-season-selection").on("click", function (e) {
  $(".js-book-btn").attr("data-selected_season", $(this).attr("data-type"));
  $(".js-book-btn").removeClass("is-disabled");
});


function seasonIdCookie($season_id) {
  document.cookie =
    "selected_season_id=" + $season_id + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}
function baseDepositCookie($base_deposit) {
  document.cookie =
    "selected_base_deposit=" + $base_deposit + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}
function priceCookie($price) {
  document.cookie =
    "selected_price=" + $price + ";path=/; max-age=" + 30 * 24 * 60 * 60;
}
$(".js-book-btn").on("click", function (e) {
  var $season_id = $(this).attr("data-selected_season_id");
  var $season = $(this).attr("data-selected_season");
  var $sport = $(this).attr("data-selected_sport");
  var $country = $(this).attr("data-selected_country");
  var $resort = $(this).attr("data-selected_resort");
  var $course_id = $(this).attr("data-selected_course");
  var $slot = $(this).attr("data-selected_slot");
  var $selected_base_deposit = $(this).attr("data-selected_base_deposit");
  var $selected_price = $(this).attr("data-selected_price");
  var $data_action = $(this).attr("data-action");

  seasonCookie($season);
  sportCookie($sport);
  countryCookie($country);
  resortCookie($resort);
  courseCookie($course_id);
  slotCookie($slot);
  seasonIdCookie($season_id);
  baseDepositCookie($selected_base_deposit);
  priceCookie($selected_price);

  window.location.href = $data_action;
});

function loadFirst() {
  var $value = $(".booking-form input[name=type_course]:checked").val();
  var $sport = $(".booking-form input[name=sport]:checked").val();
  var $destination = $(".booking-form input[name=country]:checked").val();
  var $resort = $(".booking-form input[name=resort]:checked").val();
  var $season = $(".booking-form input[name=season]:checked").val();
  var $dates = $(".booking-form input[name=date]:checked").val();
  var $price = $(".booking-form input[name=date]:checked").attr("data-price");


  if ($dates != null && $dates != undefined) {
    $(".course-content").slideUp();
    $.ajax({
      url: ajax_object.ajax_url,
      data: {
        action: "book_summary",
        course: $value,
        sport: $sport,
        destination: $destination,
        resort: $resort,
        season: $season,
        dates: $dates,
      },
      type: "POST",
      success: function (response) {
        $(".js-choose-course-validation").addClass("is-inactive");
        $(".course-content").html(response);
        $(".course-content").slideDown();
        var current = $("#package-total span").text();
        var total = $(".booking-form input[type=radio][name=date]:checked").data("price");
        var date_deposit = $(".booking-form input[type=radio][name=date]:checked").data("deposit-amount");
        $("#package-total span").prop("Counter", current).animate({ Counter: total, },
          {
            duration: 1000,
            easing: "swing",
            step: function (now) {
              $("#package-total span").text(Math.ceil(now));
            },
          }
        );
        $("#package").val(Number(total));
        var deposit = $("#deposit-total span").text();
        $("#deposit-total").attr("data-date-deposit", date_deposit);

        var initial_deposit = parseInt($("#deposit-total").attr("data-base-deposit"));
        var date_deposit = parseInt($("#deposit-total").attr("data-date-deposit"));
        var room_deposit = parseInt($("#deposit-total").attr("data-room-deposit"));
        var extras_deposit = parseInt($("#deposit-total").attr("data-extras-deposit"));

        if (date_deposit) {
          initial_deposit = date_deposit;
        }
        var current_deposit = room_deposit + initial_deposit + extras_deposit;
        current_deposit = parseInt(current_deposit);
        var deposit = $("#deposit-total span").text();

        $("#deposit-total span")
          .prop("Counter", deposit)
          .animate(
            {
              Counter: current_deposit,
            },
            {
              duration: 1000,
              easing: "swing",
              step: function (now) {
                $("#deposit-total span").text(Math.ceil(now));
              },
            }
          );
        $("#package-total").addClass("active");
        book();
      },
    });
  }
};
